// extracted by mini-css-extract-plugin
export var orderSummary = "_sv-0";
export var showMoreLessButton = "_sv-1";